import { useState, useEffect, useCallback } from 'react';
import { getAnalyticsItemCategoriesByTaxonomy } from '@mb/lib';
import { pushItemImageSelectedDataLayer } from '../../helpers/analytics';
import { ProductDetails } from '../../types/product';

export function useFullscreen(activeProduct: ProductDetails) {
  const [isFullScreen, setIsFullScreen] = useState(false);

  const handleFullScreen = useCallback(() => {
    pushItemImageSelectedDataLayer([
      {
        item_id: activeProduct?.originalMaterial?.entityId,
        item_name: activeProduct?.originalMaterial?.name,
        item_brand: activeProduct?.originalMaterial?.manufacturer,
        ...getAnalyticsItemCategoriesByTaxonomy(
          activeProduct?.originalMaterial?.taxonomy,
        ),
        index: 1,
        price: 0,
        quantity: 1,
        item_list_id: 'quick_view',
        item_list_name: 'Quick View',
        item_variant: activeProduct?.originalMaterial?.name,
      },
    ]);
    setIsFullScreen((prev) => !prev);
  }, [activeProduct]);

  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isFullScreen) {
        handleFullScreen();
      }
    };

    window.addEventListener('keydown', handleEscKey);

    return () => {
      window.removeEventListener('keydown', handleEscKey);
    };
  }, [handleFullScreen, isFullScreen]);

  return {
    isFullScreen,
    handleFullScreen,
  };
}
